/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppMainRouteRouteImport } from './routes/_app/_main/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppMainIndexRouteImport } from './routes/_app/_main/index'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsApiKeysRouteImport } from './routes/_app/settings/api-keys'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminProjectsIndexRouteImport } from './routes/_app/admin/projects/index'
import { Route as AppAdminOrganizationsIndexRouteImport } from './routes/_app/admin/organizations/index'
import { Route as AppMainProjectsIndexRouteImport } from './routes/_app/_main/projects/index'
import { Route as AppMainInboxIndexRouteImport } from './routes/_app/_main/inbox/index'
import { Route as AppAdminProjectsIdRouteImport } from './routes/_app/admin/projects/$id'
import { Route as AppAdminOrganizationsSlugRouteImport } from './routes/_app/admin/organizations/$slug'
import { Route as AppMainRequestsNewRouteImport } from './routes/_app/_main/requests/new'
import { Route as AppMainProjectsSlugRouteImport } from './routes/_app/_main/projects/$slug'
import { Route as AppMainRequestsIdIndexRouteImport } from './routes/_app/_main/requests/$id/index'
import { Route as AppMainRequestsIdDevelopRouteImport } from './routes/_app/_main/requests/$id/develop'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMainRouteRoute = AppMainRouteRouteImport.update({
  id: '/_main',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppMainIndexRoute = AppMainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminProjectsIndexRoute = AppAdminProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationsIndexRoute =
  AppAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppMainProjectsIndexRoute = AppMainProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppMainInboxIndexRoute = AppMainInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppAdminProjectsIdRoute = AppAdminProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationsSlugRoute =
  AppAdminOrganizationsSlugRouteImport.update({
    id: '/organizations/$slug',
    path: '/organizations/$slug',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppMainRequestsNewRoute = AppMainRequestsNewRouteImport.update({
  id: '/requests/new',
  path: '/requests/new',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppMainProjectsSlugRoute = AppMainProjectsSlugRouteImport.update({
  id: '/projects/$slug',
  path: '/projects/$slug',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppMainRequestsIdIndexRoute = AppMainRequestsIdIndexRouteImport.update({
  id: '/requests/$id/',
  path: '/requests/$id/',
  getParentRoute: () => AppMainRouteRoute,
} as any)
const AppMainRequestsIdDevelopRoute =
  AppMainRequestsIdDevelopRouteImport.update({
    id: '/requests/$id/develop',
    path: '/requests/$id/develop',
    getParentRoute: () => AppMainRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppMainIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/admin/': typeof AppAdminIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/projects/$slug': typeof AppMainProjectsSlugRoute
  '/requests/new': typeof AppMainRequestsNewRoute
  '/admin/organizations/$slug': typeof AppAdminOrganizationsSlugRoute
  '/admin/projects/$id': typeof AppAdminProjectsIdRoute
  '/inbox/': typeof AppMainInboxIndexRoute
  '/projects/': typeof AppMainProjectsIndexRoute
  '/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/admin/projects/': typeof AppAdminProjectsIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/requests/$id/develop': typeof AppMainRequestsIdDevelopRoute
  '/requests/$id/': typeof AppMainRequestsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppMainIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/admin': typeof AppAdminIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/projects/$slug': typeof AppMainProjectsSlugRoute
  '/requests/new': typeof AppMainRequestsNewRoute
  '/admin/organizations/$slug': typeof AppAdminOrganizationsSlugRoute
  '/admin/projects/$id': typeof AppAdminProjectsIdRoute
  '/inbox': typeof AppMainInboxIndexRoute
  '/projects': typeof AppMainProjectsIndexRoute
  '/admin/organizations': typeof AppAdminOrganizationsIndexRoute
  '/admin/projects': typeof AppAdminProjectsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/requests/$id/develop': typeof AppMainRequestsIdDevelopRoute
  '/requests/$id': typeof AppMainRequestsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_app/_main': typeof AppMainRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/_main/': typeof AppMainIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/_main/projects/$slug': typeof AppMainProjectsSlugRoute
  '/_app/_main/requests/new': typeof AppMainRequestsNewRoute
  '/_app/admin/organizations/$slug': typeof AppAdminOrganizationsSlugRoute
  '/_app/admin/projects/$id': typeof AppAdminProjectsIdRoute
  '/_app/_main/inbox/': typeof AppMainInboxIndexRoute
  '/_app/_main/projects/': typeof AppMainProjectsIndexRoute
  '/_app/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/_app/admin/projects/': typeof AppAdminProjectsIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/_main/requests/$id/develop': typeof AppMainRequestsIdDevelopRoute
  '/_app/_main/requests/$id/': typeof AppMainRequestsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/settings'
    | '/auth/callback'
    | '/settings/api-keys'
    | '/settings/notifications'
    | '/settings/profile'
    | '/admin/'
    | '/settings/'
    | '/projects/$slug'
    | '/requests/new'
    | '/admin/organizations/$slug'
    | '/admin/projects/$id'
    | '/inbox/'
    | '/projects/'
    | '/admin/organizations/'
    | '/admin/projects/'
    | '/admin/users/'
    | '/requests/$id/develop'
    | '/requests/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/auth/callback'
    | '/settings/api-keys'
    | '/settings/notifications'
    | '/settings/profile'
    | '/admin'
    | '/settings'
    | '/projects/$slug'
    | '/requests/new'
    | '/admin/organizations/$slug'
    | '/admin/projects/$id'
    | '/inbox'
    | '/projects'
    | '/admin/organizations'
    | '/admin/projects'
    | '/admin/users'
    | '/requests/$id/develop'
    | '/requests/$id'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_app/_main'
    | '/_app/admin'
    | '/_app/settings'
    | '/auth/callback'
    | '/_app/settings/api-keys'
    | '/_app/settings/notifications'
    | '/_app/settings/profile'
    | '/_app/_main/'
    | '/_app/admin/'
    | '/_app/settings/'
    | '/_app/_main/projects/$slug'
    | '/_app/_main/requests/new'
    | '/_app/admin/organizations/$slug'
    | '/_app/admin/projects/$id'
    | '/_app/_main/inbox/'
    | '/_app/_main/projects/'
    | '/_app/admin/organizations/'
    | '/_app/admin/projects/'
    | '/_app/admin/users/'
    | '/_app/_main/requests/$id/develop'
    | '/_app/_main/requests/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/_main': {
      id: '/_app/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppMainRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/_main/': {
      id: '/_app/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppMainIndexRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/api-keys': {
      id: '/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/projects/': {
      id: '/_app/admin/projects/'
      path: '/projects'
      fullPath: '/admin/projects/'
      preLoaderRoute: typeof AppAdminProjectsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/': {
      id: '/_app/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AppAdminOrganizationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/_main/projects/': {
      id: '/_app/_main/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppMainProjectsIndexRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/_main/inbox/': {
      id: '/_app/_main/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppMainInboxIndexRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/admin/projects/$id': {
      id: '/_app/admin/projects/$id'
      path: '/projects/$id'
      fullPath: '/admin/projects/$id'
      preLoaderRoute: typeof AppAdminProjectsIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/$slug': {
      id: '/_app/admin/organizations/$slug'
      path: '/organizations/$slug'
      fullPath: '/admin/organizations/$slug'
      preLoaderRoute: typeof AppAdminOrganizationsSlugRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/_main/requests/new': {
      id: '/_app/_main/requests/new'
      path: '/requests/new'
      fullPath: '/requests/new'
      preLoaderRoute: typeof AppMainRequestsNewRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/_main/projects/$slug': {
      id: '/_app/_main/projects/$slug'
      path: '/projects/$slug'
      fullPath: '/projects/$slug'
      preLoaderRoute: typeof AppMainProjectsSlugRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/_main/requests/$id/': {
      id: '/_app/_main/requests/$id/'
      path: '/requests/$id'
      fullPath: '/requests/$id/'
      preLoaderRoute: typeof AppMainRequestsIdIndexRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
    '/_app/_main/requests/$id/develop': {
      id: '/_app/_main/requests/$id/develop'
      path: '/requests/$id/develop'
      fullPath: '/requests/$id/develop'
      preLoaderRoute: typeof AppMainRequestsIdDevelopRouteImport
      parentRoute: typeof AppMainRouteRoute
    }
  }
}

interface AppMainRouteRouteChildren {
  AppMainIndexRoute: typeof AppMainIndexRoute
  AppMainProjectsSlugRoute: typeof AppMainProjectsSlugRoute
  AppMainRequestsNewRoute: typeof AppMainRequestsNewRoute
  AppMainInboxIndexRoute: typeof AppMainInboxIndexRoute
  AppMainProjectsIndexRoute: typeof AppMainProjectsIndexRoute
  AppMainRequestsIdDevelopRoute: typeof AppMainRequestsIdDevelopRoute
  AppMainRequestsIdIndexRoute: typeof AppMainRequestsIdIndexRoute
}

const AppMainRouteRouteChildren: AppMainRouteRouteChildren = {
  AppMainIndexRoute: AppMainIndexRoute,
  AppMainProjectsSlugRoute: AppMainProjectsSlugRoute,
  AppMainRequestsNewRoute: AppMainRequestsNewRoute,
  AppMainInboxIndexRoute: AppMainInboxIndexRoute,
  AppMainProjectsIndexRoute: AppMainProjectsIndexRoute,
  AppMainRequestsIdDevelopRoute: AppMainRequestsIdDevelopRoute,
  AppMainRequestsIdIndexRoute: AppMainRequestsIdIndexRoute,
}

const AppMainRouteRouteWithChildren = AppMainRouteRoute._addFileChildren(
  AppMainRouteRouteChildren,
)

interface AppAdminRouteRouteChildren {
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminOrganizationsSlugRoute: typeof AppAdminOrganizationsSlugRoute
  AppAdminProjectsIdRoute: typeof AppAdminProjectsIdRoute
  AppAdminOrganizationsIndexRoute: typeof AppAdminOrganizationsIndexRoute
  AppAdminProjectsIndexRoute: typeof AppAdminProjectsIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminOrganizationsSlugRoute: AppAdminOrganizationsSlugRoute,
  AppAdminProjectsIdRoute: AppAdminProjectsIdRoute,
  AppAdminOrganizationsIndexRoute: AppAdminOrganizationsIndexRoute,
  AppAdminProjectsIndexRoute: AppAdminProjectsIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppMainRouteRoute: typeof AppMainRouteRouteWithChildren
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppMainRouteRoute: AppMainRouteRouteWithChildren,
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
